import React, { useEffect, useState } from 'react';
import Header from '../../../Components/Header';
import Footer from '../../../Components/Footer';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ApiService } from '../../../Components/Services/apiServices';
import { FaUser, FaCalendarAlt, FaUsers } from 'react-icons/fa';  // Icons

const BookingPage = () => {
    const { room_name } = useParams();
    const [roomDetails, setRoomDetails] = useState({});
    const [checkIn, setCheckIn] = useState("");
    const [checkOut, setCheckOut] = useState("");
    const [rooms, setRooms] = useState(1);
    const [guests, setGuests] = useState(1);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();


    useEffect(() => {
        const storedUserData = localStorage.getItem("USER_DATA");
        if (storedUserData) {
            setUser(JSON.parse(storedUserData));
        }
    }, []);


    useEffect(() => {
        setCheckIn(localStorage.getItem("checkIn") || "");
        setCheckOut(localStorage.getItem("checkOut") || "");
        setRooms(localStorage.getItem("rooms") || 1);
        setGuests(localStorage.getItem("guests") || 1);
    }, []);

    useEffect(() => {
        const fetchroomDetail = async () => {
            try {
                const roomDetailData = await ApiService.Commanfetchrequest(`rooms/${room_name}`);
                setRoomDetails(roomDetailData);

            } catch (error) {
                console.error("Error fetching room details:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchroomDetail();
    }, [room_name]);

    const getFormattedDate = (dateString) => {
        const date = new Date(dateString);
        const options = { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };



    const roomBasePrice = parseFloat(roomDetails.room_price) || 0;
    const perGuestCharge = 500;

    const roomCost = roomBasePrice * rooms;
    const extraGuestCount = guests > rooms ? guests - rooms : 0;
    const extraGuestCharge = extraGuestCount * perGuestCharge;
    const subtotal = roomCost + extraGuestCharge;
    const tax = subtotal * 0.12;
    const totalPrice = subtotal + tax;
    // console.log("Total Price Sent to Backend:", totalPrice.toFixed(2));





    const handleBooking = async () => {

        if (!roomDetails || !user) {
            alert('You need to be logged in to book a room!');
            return;
        }
        const roomBasePrice = parseFloat(roomDetails.room_price) || 0;
        const perGuestCharge = 500;

        const roomCost = roomBasePrice * rooms;
        const extraGuestCount = guests > rooms ? guests - rooms : 0;
        const extraGuestCharge = extraGuestCount * perGuestCharge;
        const subtotal = roomCost + extraGuestCharge;
        const tax = subtotal * 0.12;
        const totalPrice = (subtotal + tax).toFixed(2);

        const bookingData = {
            room_name: roomDetails.room_name,
            room_price: roomBasePrice,
            rooms: rooms,
            guests: guests,
            check_in: checkIn,
            check_out: checkOut,
            total_price: totalPrice,
            user_id: user.id,
            user_name: user.username,
            user_email: user.email,
            user_mobile: user.mobile,

        };
        // console.log("Booking Data:", bookingData);

        try {
            const bookingResponse = await ApiService.Commanpostrequest("book-room", bookingData);



            if (bookingResponse.success) {
                navigate(`/booking-confirmation/${bookingResponse.booking.booking_id}`);
            } else {
                navigate(`/booking-confirmation/${bookingResponse.booking.booking_id}`);
            }
        } catch (error) {
            console.error('Booking error:', error);
        }
    };



    if (loading) {
        return <p className="text-center my-5">Loading room details...</p>;
    }

    return (
        <>
            <Header />
            <div className="container py-5">
                <div className="row">
                    <div className="col-12 text-center">

                        <div id="roomCarousel" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                {roomDetails.room_images && roomDetails.room_images.map((image, index) => (
                                    <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={image.id}>
                                        <img src={`https://hoteljpradmin.loopring.in/front/images/rooms/${image.room_images}`} className="d-block w-100" alt={`Room ${index + 1}`} />
                                    </div>
                                ))}
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#roomCarousel" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#roomCarousel" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>

                    <div className="col-12 text-center mt-3">
                        <h2 className="fw-bold">{roomDetails.room_name}</h2>
                        <p className="text-muted">{roomDetails.room_address || "Pratap Nagar, Sect-9, Jaipur-302033"}</p>
                        <Link to="#" style={{ textDecoration: "none" }} className="badge bg-success">Get Direction</Link>
                    </div>

                    <div className="col-lg-6 mx-auto mt-4">
                        <div className="card shadow-lg p-4 border-0">
                            <h4 className="fw-bold text-primary">Your Booking Details</h4>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <div>
                                    <FaCalendarAlt className="text-secondary me-2" />
                                    <strong>Check-in:</strong><br /> {getFormattedDate(checkIn)}
                                </div>
                                <div>
                                    <FaCalendarAlt className="text-secondary me-2" />
                                    <strong>Check-out:</strong><br /> {getFormattedDate(checkOut)}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <div>
                                    <FaUsers className="text-secondary me-2" />
                                    <strong>Guests:</strong> {guests}
                                </div>
                                <div>
                                    <FaUser className="text-secondary me-2" />
                                    <strong>Rooms:</strong> {rooms}
                                </div>

                            </div>
                            <div className='mt-4'>
                                <FaUser className="text-secondary me-2" />
                                <strong>Booking for:</strong><br />
                                <span style={{ marginLeft: "25px", fontSize: "13px" }}>{user?.username}</span><br />
                                <span style={{ marginLeft: "25px", fontSize: "13px" }}>{user?.email}</span>

                            </div>

                            <hr />
                            <div className="d-flex justify-content-between">
                                <strong>Base Room Price:</strong>
                                <span>₹{roomBasePrice}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <strong>Rooms Selected:</strong>
                                <span>× {rooms}</span>
                            </div>
                            {extraGuestCount > 0 && (
                                <div className="d-flex justify-content-between">
                                    <strong>Additional Guest Charge:</strong>
                                    <span>₹{extraGuestCharge}</span>
                                </div>
                            )}
                            <div className="d-flex justify-content-between">
                                <strong>Subtotal (Before Tax):</strong>
                                <span>₹{subtotal}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <strong>Tax (12%):</strong>
                                <span>₹{tax}</span>
                            </div>
                            <div className="d-flex justify-content-between text-primary fw-bold">
                                <strong>Total Price:</strong>
                                <span>₹{totalPrice}</span>
                            </div>


                            <div className="d-flex justify-content-between mt-4">
                                <button onClick={handleBooking} className="btn btn-success w-100 me-2">Book Now & Pay</button>
                                {/* <button className="btn btn-primary w-50">Pay Now</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default BookingPage;
